export default __webpack_public_path__ + "static/media/img__01.aa0a399c.jpg";